export const REMOVE_SUPPORT_MATERIAL = "REMOVE_SUPPORT_MATERIAL"
export const REMOVE_SUPPORT_MATERIAL_SUCCESS = "REMOVE_SUPPORT_MATERIAL_SUCCESS"
export const REMOVE_SUPPORT_MATERIAL_CLEAN = "REMOVE_SUPPORT_MATERIAL_CLEAN"
export const REMOVE_SUPPORT_MATERIAL_ERROR = "REMOVE_SUPPORT_MATERIAL_ERROR"
